<main class="error-page-content">
  <i class="m-icon network-check error-page-icon"></i>
  <h1 class="error-page-title" [innerHTML]="getTitle()"></h1>
  <p class="error-page-text" [innerHTML]="getText()"></p>
  <button class="btn btn-primary error-page-button" (click)="onClickRefresh()"><i class="m-icon arrow-forward"></i> {{getButtonText()}}</button>

  <!-- Show technical error details in dev/test -->
  <details *ngIf="isDev && error" class="error-page-details dev-error-block">
    <summary>Technical Details <br><small>Not shown on production</small></summary>
    <pre [innerHTML]="getFormattedError()"></pre>
  </details>
</main>
